module.exports = __webpack_public_path__ + "static/media/athos.43e68875.png";